var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"750px","font-size":"0","margin":"0 auto"},attrs:{"id":"editerHtml"}},[_c('div',{staticStyle:{"display":"none","padding-bottom":"2rem"},attrs:{"id":"pram01"}},[_c('div',{staticClass:"desc_img"},[_c('img',{staticClass:"list-img",attrs:{"src":require("@/assets/images/family/wxShareTips.jpg")}})])])])
}]

export { render, staticRenderFns }